module.exports = __webpack_public_path__ + "img/chartbg.387ad89e.png";